import { HomeBanner, LatestAppsFragment, Modes, NavBar, Search } from './Base'
import { Link, Outlet, ScrollRestoration, useNavigation } from 'react-router-dom'
import React, { createContext, memo, useCallback, useEffect, useRef, useState } from 'react'
import useTokenData from "./helpers/tokenData";
import useUserData from "./helpers/userData";
import { atom, useSetAtom } from "jotai";
import { ListApps } from './loaders/appLoaders';
import InstallPWA from './Install';

export const TokenContext = createContext({});
export const UserContext = createContext({});
export const tokenState = atom({
    rawToken: '',
    isLoggedIn: false,
    tokenData: null
});

export async function appLoader() {
    const apps = await ListApps();
    return { apps };
}

function HomeOld() {
    const accessToken = window.localStorage.getItem('nine_login');
    const setTokenDataStore = useSetAtom(tokenState);
    const scrollContainerRef = useRef(null);
    const [latestAppsCount, setLatestAppsCount] = useState(10);
    const [hasNextPage, setHasNextPage] = useState(false);
    const [isFetchingLatestApps, setIsFetchingLatestApps] = useState(false);
    const [fetchMoreLatestApps, setFetchMoreLatestApps] = useState(false);
    const [scrollData, setScrollData] = useState({});

    const { rawToken, isLoggedIn, tokenData } = useTokenData();

    useEffect(() => {
        setTokenDataStore({ rawToken, isLoggedIn, tokenData });
        return () => { }
    }, [tokenData]);

    useEffect(() => {
        // handle Scroll check
        const scrollContainerElem = scrollContainerRef.current;
        const handleScroll = () => {
            // Get the last container height as on offset for the scroll calculation.
            if (document.getElementById('id-latest-apps-container') !== null) {
                const lastElement = document.getElementById('id-latest-apps-container').lastElementChild;
                const lastElementHeight = lastElement.clientHeight;
                setScrollData({
                    "scrollHeight": scrollContainerElem.scrollHeight,
                    "scrollTop": scrollContainerElem.scrollTop,
                    "clientHeight": scrollContainerElem.clientHeight,
                    "lastElementHeight": lastElementHeight
                });
                if (scrollContainerElem.scrollHeight - scrollContainerElem.scrollTop - lastElementHeight <= scrollContainerElem.clientHeight) {
                    // we've reached the bottom of the scrollContainerElem
                    console.log("Reached the bottom of the page.");
                    // alert("Reached the bottom of the page.");
                    setFetchMoreLatestApps(true);
                }
            }
        };

        scrollContainerElem.addEventListener("scroll", handleScroll);
        return () => { scrollContainerElem.removeEventListener("scroll", handleScroll) }
    }, []);

    const handleScroll = useCallback(() => {
        const scrollContainerElem = scrollContainerRef.current;
        if (scrollContainerElem.scrollHeight - scrollContainerElem.scrollTop === scrollContainerElem.clientHeight) {
            // we've reached the bottom of the scrollContainerElem
            console.log("Reached the bottom of the page.");
        }
    }, [isFetchingLatestApps]);

    const handleFetchData = useCallback(() => {
        // const data = useFetch(`${process.env.REACT_APP_BASE_URL}/app/`);
        setIsFetchingLatestApps(false);
        setFetchMoreLatestApps(false);
        // return data;
    }, []);

    // const {rawToken, isLoggedIn, tokenData} = useAtomValue(tokenState);
    // const {rawToken, isLoggedIn, tokenData} = useRecoilValue(tokenState);
    const { userDataResults, isError, isLoading, responseDetails } = useUserData();

    return (
        // <RecoilRoot>
        <TokenContext.Provider value={tokenData}>
            {/*<UserContext.Provider value={userDataResults}></UserContext.Provider>*/}
            <div className="flex flex-column flex-nowrap w-inherit vh:h-100 overflow-y-auto class-nine-dark-0:bg-000304 class-nine-dark-1:bg-111314 class-nine-dark-2:bg-222324 class-nine-dark-3:bg-333334" ref={scrollContainerRef}>
                {/*<div className={"sticky top-0 z-1000"}>{scrollData?.scrollHeight} - {scrollData?.scrollTop} - {scrollData?.lastElementHeight} ({scrollData?.scrollHeight - scrollData.scrollTop - scrollData.lastElementHeight}) == {scrollData?.clientHeight} -> {fetchMoreLatestApps ? "Fetching" : "Not fetching"}</div>*/}
                {/*{JSON.stringify(tokenData)} - TOkenData*/}
                {/*{tokenData?.email}*/}
                {/*{setTokenDataStore({rawToken, isLoggedIn, tokenData})}*/}
                {/* <Templates /> */}
                <NavBar showAddAppButton={true} />
                {
                    isLoggedIn && tokenData?.is_verified !== undefined && !tokenData?.is_verified
                        ? <div className={"sticky px:top-80 flex flex-row align-items-center pad-1 bg-yellow-inverse bg-mica z-90 lg:justify-center"}>
                            <span>Your account is not yet verified.</span>
                            <Link
                                to={"/verify-user"}
                                className={"d-block h-5 lh-5 mg-l2 pad-x2 bg-yellow color-black text-center radius decoration-none"}>
                                Verify account
                            </Link>
                        </div>
                        : null
                }
                <HomeBanner />
                <LatestAppsFragment listCount={latestAppsCount} fetchData={handleFetchData} fetchMoreData={fetchMoreLatestApps}></LatestAppsFragment>
                {/* <div className="napps grid-x4 grid-y4 box"></div> */}

                {/* <div className="fixed fixed-x9 fixed-y7 line-height-6 radius-round bg-blue pad-x2" onClick={new NEH().drawNewAppsFormTemplate}>Create App</div> */}

                {/*{accessToken
                        ? <Link to="/new"
                                className="fixed lg:top-2 lg:bottom-unset lg:right-4 right-8 top-initial bottom-4 z-100 h-8 line-height-8 radius-round bg-green-solid color-white pad-x4 cursor-pointer font-semibold shadow:0px-0px-16px-4px-73C088 decoration-none"
                                onClick={new NEH().drawNewAppsFormTemplate}>
                            Add your App
                        </Link>
                        : <Link to="/login"
                                className="fixed lg:top-2 lg:bottom-unset lg:right-4 right-8 top-initial bottom-4 z-100 h-8 line-height-8 radius-round bg-green-solid color-white pad-x4 cursor-pointer font-semibold shadow:0px-0px-16px-4px-73C088 decoration-none"
                                onClick={new NEH().drawNewAppsFormTemplate}>
                            Add your Apps
                        </Link>
                    }*/}
                {/* <div className="abs abs-x4 abs-y2 square-6 line-height-6 radius-sm2 bg-green">A</div> */}
                {/* <div className="abs abs-x1 abs-y3 square-10 line-height-10 radius-round bg-blue">B</div> */}
                {/* <div className="abs abs-x1 abs-y12 square-8 line-height-8 radius-round bg-lighter border">C</div> */}

                <Modes modes_id="id-search-page-fragment-modes" modes_class="modes modes-white modes-fullscreen">
                    {/* SEARCH MODES - HURRAY... */}
                    {/* <Templates search_template={true} /> */}
                    <Search>
                        {/* Let's Populate the search bar with a search form. */}
                    </Search>
                </Modes>

                {/*<Modes modes_id="id-new-app-form-modes" modes_class="modes modes-white modes-fullscreen">*/}
                {/*  <CreateForm></CreateForm>*/}
                {/*</Modes>*/}
                {/* <Link to="/"></Link> */}

                {/*<Modes modes_id="id-app-details-modes" modes_class="modes modes-white modes-fullscreen modes-anim-slideup">*/}
                {/*  <AppDetail></AppDetail>*/}
                {/*</Modes>*/}

                {/*<header className="App-header">
                <img src={logo} className="App-logo" alt="logo" />
                <p>
                  Edit <code>src/App.js</code> and save to reload.
                </p>
                <a
                  className="App-link"
                  href="https://reactjs.org"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Learn React
                </a>
              </header>*/}

                {/* <ScrollRestoration /> */}
                {/* <ScrollRestoration
                    getKey={(location, matches) => {
                        return location.pathname;
                    }}
                /> */}
                {/* <Outlet /> */}
            </div>
        </TokenContext.Provider>
        // </RecoilRoot>
    )
}


function Home() {
    const navigation = useNavigation();
    const accessToken = window.localStorage.getItem('nine_login');
    const setTokenDataStore = useSetAtom(tokenState);
    const scrollContainerRef = useRef(null);
    const [latestAppsCount, setLatestAppsCount] = useState(10);
    // const [hasNextPage, setHasNextPage] = useState(false);
    const [isFetchingLatestApps, setIsFetchingLatestApps] = useState(false);
    const [fetchMoreLatestApps, setFetchMoreLatestApps] = useState(false);
    // const [scrollData, setScrollData] = useState({});

    const { rawToken, isLoggedIn, tokenData } = useTokenData();

    useEffect(() => {
        setTokenDataStore({ rawToken, isLoggedIn, tokenData });
        return () => { }
    }, [tokenData]);

    useEffect(() => {
        // handle Scroll check
        const scrollContainerElem = scrollContainerRef.current;
        const handleScroll = () => {
            // Get the last container height as on offset for the scroll calculation.
            if (document.getElementById('id-latest-apps-container') !== null) {
                const lastElement = document.getElementById('id-latest-apps-container').lastElementChild;
                const lastElementHeight = lastElement.clientHeight;
                /*
                setScrollData({
                    "scrollHeight": scrollContainerElem.scrollHeight,
                    "scrollTop": scrollContainerElem.scrollTop,
                    "clientHeight": scrollContainerElem.clientHeight,
                    "lastElementHeight": lastElementHeight
                });
                */
                if (scrollContainerElem.scrollHeight - scrollContainerElem.scrollTop - lastElementHeight <= scrollContainerElem.clientHeight) {
                    // we've reached the bottom of the scrollContainerElem
                    console.log("Reached the bottom of the page.");
                    setFetchMoreLatestApps(true);
                }
            }
        };

        scrollContainerElem.addEventListener("scroll", handleScroll);
        return () => { scrollContainerElem.removeEventListener("scroll", handleScroll) }
    }, []);

    const handleScroll = useCallback(() => {
        const scrollContainerElem = scrollContainerRef.current;
        if (scrollContainerElem.scrollHeight - scrollContainerElem.scrollTop === scrollContainerElem.clientHeight) {
            // we've reached the bottom of the scrollContainerElem
            console.log("Reached the bottom of the page.");
        }
    }, [isFetchingLatestApps]);

    const handleFetchData = useCallback(() => {
        // const data = useFetch(`${process.env.REACT_APP_BASE_URL}/app/`);
        setIsFetchingLatestApps(false);
        setFetchMoreLatestApps(false);
        // return data;
    }, []);

    const resendVerificationCode = () => {
        const resendVerificationCodeFormData = new FormData()
        resendVerificationCodeFormData.append("email", tokenData?.email);
        const resendVerifyUserCodeURL = `${process.env.REACT_APP_BASE_URL}/user/resend-registration-code/`;
        const headers = {
            'Accept': '*/*',
            // 'Origin': '*',
        };
        const fetchInit = {
            method: 'POST',
            headers: headers,
            mode: 'cors',
            body: resendVerificationCodeFormData,
            cache: 'default',
        };

        fetch(resendVerifyUserCodeURL, fetchInit)
            .then(response => {
                if (!response.ok) { }
                return response.json();
            })
            .then(() => null)
            .catch(() => null);
    };

    return (
        <div className="flex flex-column flex-nowrap w-inherit vh:h-100 overflow-y-auto class-nine-dark-0:bg-000304 class-nine-dark-1:bg-111314 class-nine-dark-2:bg-222324 class-nine-dark-3:bg-333334" ref={scrollContainerRef}>
            {/* {navigation.state === "loading" && <PageLoader />} */}
            <NavBar showAddAppButton={true} />
            {
                isLoggedIn && tokenData?.is_verified !== undefined && !tokenData?.is_verified
                    ? <div className={"sticky px:top-80 flex flex-row align-items-center pad-1 bg-yellow-inverse bg-mica z-90 lg:justify-center"}>
                        <span>Your account is not yet verified.</span>
                        <Link
                            to={"/verify-user"}
                            onClick={resendVerificationCode}
                            className={"d-block h-5 lh-5 mg-l2 pad-x2 bg-yellow color-black text-center radius decoration-none"}>
                            Verify account
                        </Link>
                    </div>
                    : null
            }
            <InstallPWA />
            <HomeBanner />
            <LatestAppsFragment listCount={latestAppsCount} fetchData={handleFetchData} fetchMoreData={fetchMoreLatestApps}></LatestAppsFragment>

            {/* <ScrollRestoration /> */}
            {/* <Outlet /> */}
        </div>
    )
}

export default memo(Home)